module.exports = "/assets/data/82756b1d3ed10abf71a7478d046c276f-LL18.data.json";